
import React from 'react'
import ManaString from '@/components/Spellify/ManaString/ManaString'
import { specialSymbols } from '@/lib/constants'

type Props = {
    cardfield?: string,
    word: string,
    correctGuesses: string[],
    fieldRevealed?: any,
    size?: number,
    className?: string,
    lengthIndex?: number,
}


const HiddenField = ({
    cardfield,
    word,
    correctGuesses, 
    fieldRevealed,
    size,
    className
} : Props) => {
    let inBraces = false
    let lowerGuesses = correctGuesses.map(guess => guess.toLowerCase())
    const maskedText = fieldRevealed ? word : word.split('')
                        .map((rawLetter: string) => {
                          const letter = rawLetter.toLowerCase()
                            if (letter === '{') inBraces = true
                            if (letter === '}') inBraces = false
                            return (
                              (!inBraces && lowerGuesses.includes(letter)) ||
                                specialSymbols.includes(letter) ||
                                (inBraces && lowerGuesses.includes(`{${letter}}`))
                            ) ? 
                            rawLetter : "_"})
                        .join("")
        // const maskedText = fieldRevealed ? word : word.split('')
        // .map((letter: string, i) => {
        //     const isCorrect = correctGuesses.includes(letter) || specialSymbols.includes(letter)
                        
        //     return (
        //     <span key={i} style={isCorrect ? {margin: '0 min(0.1vh, 0.1vw)'} : {borderBottom: '1px solid black', margin: '0 min(0.1vh, 0.1vw)'}} >
        //         <span style={isCorrect ? {}: {opacity: 0}}>{letter}</span>
        //     </span>
        //     )})

    return (
        <div className={className}>
            {/* {maskedText} */}
            <ManaString line={maskedText} pid={cardfield || className} size={size}/>
        </div>
    )
}

export default HiddenField